export default function createCrashReporter(errorTracker, stateSanitizerFn) {
  if (!errorTracker) {
    throw new Error('errorTracker is required!');
  }

  return store => next => action => {
    // eslint-disable-line consistent-return
    try {
      next(action);
    } catch (error) {
      let stateToSend = store.getState();

      if (typeof stateSanitizerFn === 'function') {
        stateToSend = stateSanitizerFn(stateToSend);
      }

      errorTracker.notify(error, {
        metaData: {
          action: JSON.stringify(action),
          state: JSON.stringify(stateToSend),
        },
      });
    }
  };
}
